module.exports = __webpack_public_path__ + "static/media/cycling-icon.cd0cb8e3.svg";